import { inject, Injectable } from '@angular/core';
import { LoggingService } from './logging.service';

@Injectable({ providedIn: 'root' })
export class InAppReviewService {
  private readonly loggingService = inject(LoggingService);
  private isNativePlatform(): boolean {
    const capacitor = (window as unknown as { Capacitor?: { isNativePlatform?: () => boolean } }).Capacitor;
    return capacitor?.isNativePlatform?.() ?? false;
  }

  async requestReview(): Promise<void> {
    if (!this.isNativePlatform()) {
      return;
    }

    try {
      const { CapgoInAppReview } = await import('@capgo/capacitor-in-app-review');
      await CapgoInAppReview.requestReview();
    } catch (error) {
      this.loggingService.logException(error, '[InAppReview] Failed to request review:');
    }
  }
}
